import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';
import { ComputedRef, InjectionKey } from 'vue';

// ?preferred_variant=APPLE_CHANNELS_EXP:control
// ?preferred_variant=APPLE_CHANNELS_EXP:variant_1
// ?preferred_variant=APPLE_CHANNELS_EXP:variant_2
// ?preferred_variant=APPLE_CHANNELS_EXP:variant_3

// ?remove_preferred_experiment=APPLE_CHANNELS_EXP

export const AppleChannelsExpName = 'APPLE_CHANNELS_EXP' as const;

export type AppleChannelsExpVariants = ToVariants<typeof AppleChannelsExpVariants>;

export const AppleChannelsExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
} as const;

export const APPLE_CHANNELS_EXP_KEY = Symbol() as InjectionKey<ComputedRef<AppleChannelsExpVariants | null>>;

export default generate(AppleChannelsExpName, AppleChannelsExpVariants);

export function getAppleChannelsExpAmazonTag(country: string) {
	if (country === 'CA') return 'amazon-applcha-co-20';
	if (country === 'GB') return 'amazon-applcha-co-21';
	return 'amazon-applcha-co-22';
}
